export function recoveryRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_RECOVERY_ACTION_START":           
        case "FETCH_RECOVERY_ACTION_START":           
        case "DELETE_RECOVERY_ACTION_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_RECOVERY_ACTION_FULFILLED":           
        case "FETCH_RECOVERY_ACTION_FULFILLED":           
        case "DELETE_RECOVERY_ACTION_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_RECOVERY_ACTION_ERROR":
        case "FETCH_RECOVERY_ACTION_ERROR":
        case "DELETE_RECOVERY_ACTION_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}